export const locales = ['en', 'de'] as const;
export type LocaleValue = (typeof locales)[number];

export class Locale {
  value: LocaleValue;

  constructor(locale: LocaleValue) {
    this.value = locale;
  }

  set(locale: LocaleValue) {
    this.value = locale;
  }

  get(): LocaleValue {
    return this.value;
  }
}

export const locale = new Locale('de');
